
import Vue, { PropType } from 'vue'
import { IProductMnn } from 'types/DTO/products'
import RPHButton from 'rph/atoms/RPHButton/index.vue'

export default Vue.extend({
  name: 'RPHProductMnns',
  components: {
    RPHButton,
  },
  props: {
    mnns: {
      type: Array as PropType<IProductMnn[]>,
      default: () => [] as PropType<IProductMnn[]>,
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    mnnsArr(): any {
      if (this.$props.mnns && Array.isArray(this.$props.mnns) && this.$props.mnns.length) {
        return this.$props.mnns.slice(0, 3)
      } else {
        return []
      }
    },
  },
})
